// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/PermissionModal/styles.scss
// module id = 842
// module chunks = 0